import { styled } from "../../../styles";

// Components
export const SurveysListTableContainer = styled("section", {
  position: "relative",
  height: "calc(100vh - 200px)",
  maxHeight: "800px",
  marginTop: "$5",
});

/**
 * EN-5191: the two actions used to be absolutely positioned siblings, the second pushed clear of
 * the first with a hard-coded `right: 100px` — the width of "Answer" in English. Any longer
 * translation ("Beantwoorden") slid straight under its neighbour. A flex row lets each button
 * size itself and the gap hold them apart, in any language.
 */
export const SurveyListActions = styled("div", {
  display: "flex",
  gap: "$2",
  alignItems: "center",

  position: "absolute",
  top: "-32px",
  right: "10px",
});

export const AddSurveyButton = styled("div", {
  width: "max-content",
  // No fixed height: 26px fits one line of 16px text plus its padding, and a button that wraps
  // in a longer language needs to grow rather than clip.
  minHeight: "26px",
  padding: "5px 11px",

  backgroundColor: "#212121",
  borderRadius: "12px",
  color: "$white",

  fontSize: "12px",
  lineHeight: "16px",
  fontFamily: "$openSans",
  fontWeight: "500",
  whiteSpace: "nowrap",

  cursor: "pointer",
});
